import React from 'react';

export const Categories = React.lazy(() => import('./Categories/Categories').then((m) => ({ default: m.Categories })));
